import * as React from 'react';
import { createSubcomponent } from '@workday/canvas-kit-react/common';
import { SecondaryButton } from '@workday/canvas-kit-react/button';
import { usePopupTarget, usePopupModel } from './hooks';
export const PopupTarget = createSubcomponent(SecondaryButton)({
    displayName: 'Popup.Target',
    modelHook: usePopupModel,
    elemPropsHook: usePopupTarget,
})((elemProps, Element) => {
    return React.createElement(Element, Object.assign({}, elemProps));
});
